export default __webpack_public_path__ + "images/0x38628cb4cc74cbdfb6ddd877b17c1f60fcae7c2c.png";